<template>
  <header class="mb-5">
    <b-container>
      <b-navbar toggleable="md" fixed>
        <router-link :to="{ name: 'Landing' }">
          <span class="navbar-brand">
            <img
              class="logo-img"
              src="~img/fingers-meet.png"
              alt="Fingers Meet"
            />
            Fingers Meet
          </span>
        </router-link>
      </b-navbar>
    </b-container>
  </header>
</template>

<script>
  export default {
    name: "Header",
  };
</script>
